import http from '@common/oneclub/services/http'
import { SellerAppApplyCreateRequest } from './serviceApply'
import { oneConfig } from '../one-config'
import { ValuesType } from 'utility-types'
import type * as UserType from '@common/oneclub/constants/userType'
import type { OneConfigRoot } from '@yy/one-config/libs/one-config'

export type CountryType = 'CN' | 'SG' | 'MY' | 'TH' | 'VN' | 'HK' | 'TW' | 'GB'

export interface SellerInfoReq {
  /** 是否需要查询商家的oa合同签约地址 */
  needOaContractUrl?: boolean
  /** 如果needOaContractUrl=true，则urlType不允许为空 CONTRACT_WEB_LIST( "CONTRACT_WEB_LIST","web页面" ),CONTRACT_H5_PROCESS( "CONTRACT_H5_LIST","h5页面" ) */
  urlType?: string
}

// 申请注销
export const sellerInfoDelete = () => http.normal.post('/api/seller/info/cancellation')

export interface SellerAppApplyDetailReqDTO {
  /**服务申请类型 */
  appApplyType?: string
  companyCode?: string
}

/** 获取申请服务详情 */
export const getApplyDetail = (parmas: SellerAppApplyDetailReqDTO) => http.normal.post<SellerAppApplyCreateRequest>('/api/seller/appApply/detail', parmas)

export type IgetApplyKycConfigRes = Record<
  string,
  {
    visible: Record<string, boolean>
    defaultValue: Record<string, any>
  }
>

/** 获取oms配置 */
export const getTargetOmsConfig = async <T extends keyof OneConfigRoot>(key: T) => {
  return oneConfig.get(key)
}

interface VerificationSendReqDTO {
  /**手机号 */
  phone: string
  countryCode: string
}

/**
 * **接口** [发送验证码↗](https://api-doc-sl.inshopline.com/#/project/Java/226/feature%2F20230626_1510_contract/interface/5dca5ec877a9e7d678b253faa03e3ac7)
 * @请求头 `POST /api/message/send_code`
 * @更新时间 `2023-06-05 20:40:08`
 */
export function postSendCode(data?: VerificationSendReqDTO) {
  return http.normal.post(`/api/message/send_code`, data)
}

export interface ContractCompanyDetailReqDTO {
  phone: string
  /**验证码（约束：verificationCode must not be blank） */
  verificationCode: string
  /**公司名称（约束：companyName must not be blank） */
  companyName: string
  /**联系人（约束：contacts must not be blank） */
  contacts: string
  /**开户行 */
  bank?: string
  /**账号名称 */
  bankAccountName?: string
  /**银行账号 */
  bankAccountNo?: string
  /**签署邮箱 */
  signingEmail?: string
  /** 提交的页面类型 CONTRACT_WEB_LIST( "CONTRACT_WEB_LIST","web页面" ),CONTRACT_H5_PROCESS( "CONTRACT_H5_LIST","h5页面" )（约束：urlType must not be blank） */
  urlType: SIGN_URL_TYPE
}
export enum SIGN_URL_TYPE {
  CONTRACT_WEB_LIST = 'CONTRACT_WEB_LIST',
  CONTRACT_H5_PROCESS = 'CONTRACT_H5_LIST',
}
/**
 * **接口** [提交对公合同↗](https://api-doc-sl.inshopline.com/#/project/Java/226/feature%2F20230626_1510_contract/interface/c066055a5ddc2a9d052507310a340227)
 * @请求头 `POST /api/contract/commit_company`
 * @更新时间 `2023-06-05 20:40:07`
 */
export function postCommitCompany(data: ContractCompanyDetailReqDTO) {
  return http.normal.post<{ oaContractUrl: string }>(`/api/contract/commit_company`, data)
}

export interface ContractPersonDetailReqDTO {
  /**姓名（约束：name must not be blank） */
  name: string
  /**手机号（约束：phone must not be blank） */
  phone: string
  /**验证码（约束：verificationCode must not be blank） */
  verificationCode: string
  /**开户行 */
  bank?: string
  /**账号名称 */
  bankAccountName?: string
  /**银行账号 */
  bankAccountNo?: string
  /**签署邮箱 */
  signingEmail?: string
  urlType: 'CONTRACT_WEB_LIST' | 'CONTRACT_H5_LIST'
}
/**
 * **接口** [提交对私合同↗](https://api-doc-sl.inshopline.com/#/project/Java/226/feature%2F20230626_1510_contract/interface/d315296e1deca4dc0ac1281cc8bd0dce)
 * @请求头 `POST /api/contract/commit_person`
 * @更新时间 `2023-06-05 20:40:07`
 */
export function postCommitPerson(data: ContractPersonDetailReqDTO) {
  return http.normal.post<{ oaContractUrl: string }>(`/api/contract/commit_person`, data)
}

export interface BaseUserInfo {
  /** 是否激活 */
  activated: boolean
  /** 是否禁用 */
  banned: boolean
  /** 国家 */
  countryCode: CountryType
  /** 国家对应币种 */
  countryCurrencyCode: string
  /** 区号 */
  areaCode: number
  /** 手机号 */
  phone: string
  /** email */
  email: string
  /** 是否为主账号 */
  mainAccount?: boolean
  /** 名字 */
  nickname: string
  /** 账户名称 */
  oneshipName: string
  /** uid */
  uid: string
  /** 用户类型 */
  userType: ValuesType<typeof UserType>
  /** 商家 ID */
  sellerId?: string
  /** 注册类型 */
  registrySource?: string
  /** 账号类型 MAIN-母账号，SUB-子账号，OP-运营超管 */
  accountType?: 'MAIN' | 'SUB' | 'OP'
  /** 商家名称 */
  sellerName: string
}

/**
 * 获取seller基础信息
 * @returns
 */
export function getSellerBasic() {
  return http.normal.post<BaseUserInfo>('/api/user/info/get-seller-basic')
}

// 根据商家id获取仓库信息 返回数据
export interface IWarehouseInoList<T = string> {
  country: string
  warehouseExpresses: any[]
  address: string
  warehouseId: string
  providerId: string
  warehouseTpwId: string
  warehouseName: string
  warehouseNames: Record<string, string>
  providerName: string
  enable: boolean
  /**
   * json string
   * IWarehouseExpressItemExitInfo
   **/
  extInfo?: string
  /** 是否支持不良品 */
  supportBadGoodsOutbound?: boolean
  /** 一级 */
  province?: string
  /** 二级 */
  city?: string
  /** 三级 */
  district?: string
  /** 四级 */
  town?: string
  /**仓库联系人 */
  name?: string
  /**仓库联系人手机 */
  mobile?: string
  /**仓库联系人电话 */
  phone?: string
  /**仓库联系人邮箱 */
  email?: string
  /** 地址2 */
  addressTwo?: string
  /**  */
  zipCode?: string
  /** 温层 */
  storageTypeList?: (string | number)[]
  /** 不自动执行出货时间 */
  nonAutoShipmentTimeList?: InonAutoShipmentTime[]
  multiLogisticsSupported?: boolean
  /** 商品信息填写规则配置 */
  providerFieldConfigs?: ProviderFieldConfig<T>[]
  /** 是否启用商家退货地址 */
  sellerRefundAddressEnable?: boolean
}

interface InonAutoShipmentTime {
  day: number
  rest: boolean
  detail: {
    startTime: string
    endTime: string
  }
}

type GoodFieldNameType = 'weight' | 'volume' | 'skuEnName' | 'barcode' | 'skuTitle' | 'skuZhName'

interface ProviderFieldConfig<T = string> {
  /** 字段配置信息 */
  fieldConfig: T
  fieldName: GoodFieldNameType
}
export function getWarehoseInfo() {
  return http.normal.post<IWarehouseInoList[]>('/api/seller-express/list')
}

export interface SysResource {
  resourceId: string
  key: string
  resourceName: string
  resourceCode: string
  resourceType: string
  resourceUrl: string
  banned: string
  accessControl: string
  parentId: string
  priority: string
  system: string
  children: SysResource[]
}

/**
 * 获取全部菜单权限
 * @param data
 * @returns
 */
export function getSellerPermission(data: { sourceSystem: 'ONEWAREHOUSE' | 'ONESHIP' }) {
  return http.normal.post<{ resourceTree: SysResource[] }>('/api/admin/setting/sys-resources', data)
}

/**
 * 获取指定账号拥有的菜单权限id
 * @param data
 * @returns
 */
export function getUserResources(data: { sourceSystem: 'ONEWAREHOUSE' | 'ONESHIP'; adminUid: string }) {
  return http.normal.post<{ resourceIds: string[] }>('/api/admin/setting/user-resources', data)
}

function getUserResourcesTree(tree: SysResource[], permissionIds: string[]) {
  return tree.filter((item) => {
    if (permissionIds.includes(item.resourceId)) {
      if (item.children && item.children.length) {
        item.children = getUserResourcesTree(item.children, permissionIds)
      }
      return true
    }
    return false
  })
}

/**
 * 获取指定账号拥有的菜单权限
 * @param data
 * @returns
 */
export async function getUserPermission(data: { sourceSystem: 'ONEWAREHOUSE' | 'ONESHIP'; adminUid: string }) {
  const [res1, res2] = await Promise.all([getSellerPermission({ sourceSystem: data.sourceSystem }), getUserResources(data)])
  const allPermission = res1.data.resourceTree
  const permissionIds = res2.data.resourceIds
  return getUserResourcesTree(allPermission, permissionIds)
}
